routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.consultCrm', {
      url: "/consultas",
      template: `<consult-crm sh-ctrl="shCtrl"></consult-crm>`
    });
}

export default routesConfig;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/consult-crm/consult-crm.config.js
 **/